import { render, staticRenderFns } from "./Typo420Config.vue?vue&type=template&id=6fe5849c&scoped=true&"
import script from "./Typo420Config.vue?vue&type=script&lang=js&"
export * from "./Typo420Config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe5849c",
  null
  
)

export default component.exports